// Root type
export const SYSTEM_ROOT = 'system/';

// Actions types
export const CHECK_CREDENTIALS = 'checkCredentials';
export const GET_SYSTEM_CACHE_LIST = 'getSystemCacheList';
export const RELOAD_CACHE = 'reloadCache';
export const GET_JOBS_LOGS_LIST = 'getJobsLogsList';
export const GET_JOB_LOG = 'getJobLog';
export const GET_QUARTZ_INFO = 'getQuartzInfo';
export const PAUSE_QUARTZ_TRIGGER = 'pauseQuartzTrigger';
export const RESUME_QUARTZ_TRIGGER = 'resumeQuartzTrigger';
export const START_QUARTZ_SCHEDULER = 'startQuartzScheduler';
export const STANDBY_QUARTZ_SCHEDULER = 'standbyQuartzScheduler';
export const CREATE_FORMS_FILTERS = 'createFormsFilters';
export const CREATE_STATISTICS = 'createStatistics';
export const RUN_FORM_101_PDF_GENERATOR_JOB = 'runForm101PdfGeneratorJob';
export const RUN_FORM_101_PDF_FILES_EXPORT_JOB = 'runForm101PdfFilesExportJob';
export const RUN_FORM_101_PDF_COMSIGN_JOB = 'runForm101PdfComsignJob';
export const EMPLOYEE_REMINDERS_SEND = 'employeeRemindersSend';
export const EMPLOYEE_REMINDERS_PRE_SEND = 'employeeRemindersPreSend';
export const TEST_MAILS = 'testMails';
export const STATISTICS_REPORT = 'sendForm101StatisticsReport';
export const PROCESS_COMPARE_REQUESTS = 'processCompareRequests';
export const EMPLOYEE_DETAILS_UPDATE = 'employeeDetailsUpdate';
export const SYSTEM_INFO_ACCESSIBLE = 'systemInfoAccessible';
export const REFRESH_APPLICATION_USER_VIEW = 'refreshApplicationUserView';
export const MAINTENANCE_PAGE = 'maintenancePage';
export const UPDATE_FORM_101_FILTERS = 'updateForm101Filters';
export const REFRESH_INDEX_DATA_BASE = 'refreshIndexDatabase';

// Getters types
export const SYSTEM_ERRORS = 'systemErrors';
export const SYSTEM_QUARTZ_ERRORS = 'systemQuartzErrors';
export const SYSTEM_JOBS_ERRORS = 'systemJobsErrors';
export const SYSTEM_STATISTICS_ERRORS = 'systemStatisticsErrors';
export const LOGIN_PENDING = 'loginPending';
export const SYSTEM_CACHE_LIST = 'systemCacheList';
export const SYSTEM_JOBS_LOGS_LIST = 'systemJobsLogsList';
export const SYSTEM_JOB_LOG = 'systemJobLog';
export const TOKEN = 'token';
export const QUARTZ_INFO = 'quartzInfo';
export const FORMS_FILTERS = 'formsFilters';
export const RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS = 'runForm101PdfGeneratorJobErrors';
export const RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS = 'runForm101PdfFilesExportJobErrors';
export const RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS = 'runForm101PdfComsignJobErrors';
export const TEST_MAILS_ERRORS = 'testMailsErrors';
export const STATISTICS_REPORT_ERRORS = 'statisticsReportErrors';
export const PROCESS_COMPARE_REQUEST = 'processCompareRequest';
export const PROCESS_COMPARE_REQUESTS_ERRORS = 'processCompareRequestsErrors';
export const PROCESS_COMPARE_REQUESTS_LOADING = 'processCompareRequestsLoading';
export const OPEN_TERMS_AND_PRIVACY_MODAL = 'openTermsAndPrivacyModal';

// Mutations types
export const SET_CREDENTIALS = 'setCredentials';
export const SET_SYSTEM_ERRORS = 'setSystemErrors';
export const SET_SYSTEM_QUARTZ_ERRORS = 'setSystemQuartzErrors';
export const SET_SYSTEM_JOBS_ERRORS = 'setSystemJobsErrors';
export const SET_SYSTEM_STATISTICS_ERRORS = 'setSystemStatisticsErrors';
export const SET_LOGIN_PENDING = 'setLoginPending';
export const SET_SYSTEM_CACHE_LIST = 'setSystemCacheList';
export const SET_SYSTEM_JOBS_LOGS_LIST = 'setSystemJobsLogsList';
export const SET_SYSTEM_JOB_LOG = 'setSystemJobLog';
export const SET_TOKEN = 'setToken';
export const SET_QUARTZ_INFO = 'setQuartzInfo';
export const SET_FORMS_FILTERS = 'setFormsFilters';
export const SET_RUN_FORM_101_PDF_GENERATOR_JOB_ERRORS = 'setRunForm101PdfGeneratorJobErrors';
export const SET_RUN_FORM_101_PDF_FILES_EXPORT_JOB_ERRORS = 'setRunForm101PdfFilesExportJobErrors';
export const SET_RUN_FORM_101_PDF_COMSIGN_JOB_ERRORS = 'setRunForm101PdfComsignJobErrors';
export const SET_TEST_MAILS_ERRORS = 'setTestMailsErrors';
export const SET_STATISTICS_REPORT_ERRORS = 'setStatisticsReportErrors';
export const SET_PROCESS_COMPARE_REQUEST = 'setProcessCompareRequest';
export const SET_PROCESS_COMPARE_REQUESTS_ERRORS = 'setProcessCompareRequestsErrors';
export const SET_PROCESS_COMPARE_REQUESTS_LOADING = 'setProcessCompareRequestsLoading';
export const SET_OPEN_TERMS_AND_PRIVACY = 'setOpenTermsAndPrivacyModal';
